<h4><span class="badge rounded" [ngClass]="{'bg-danger':value<0,
    'bg-success':value>0,
    'bg-info':value==0}">
        {{ value | thousandSeparatorWithDecimals}}
    </span>
</h4>